import React from 'react';
import './BrandCopyright.css';

export default function BrandCopyright({
  className = '',
  colorClass = 'text-gray-600',
  marginClass = 'mt-6',
  alignClass = 'text-center',
}) {
  return (
    <p className={`brandcopyright-root ${alignClass} ${colorClass} text-sm ${marginClass} drop-shadow-lg ${className}`}>
      <span>© 2026 Senerfi S.A.S.</span><br />
      <span>Soluciones que Generan Desarrollo</span>
    </p>
  );
}
